import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const FixWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
  padding: 90px 0 26px 0;
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`

export const Step = styled.div<{ $selected: boolean }>`
  width: 20px;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  border: 1px solid;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease, border-color 0.3s ease, color 0.3s ease;

  border-color: ${({ $selected }) =>
    $selected ? myPalette.midnightBlue.main : myPalette.blue.lightSteelBlue};
  background: ${({ $selected }) =>
    $selected ? myPalette.midnightBlue.main : myPalette.white.main};
  color: ${({ $selected }) =>
    $selected ? myPalette.white.main : myPalette.blue.lightSteelBlue};
`
